var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMobileViewPort
    ? _c(
        "div",
        {
          staticClass: "plan",
          class: {
            "mature-users": _vm.useExperimentStyling,
            extended: _vm.extended
          },
          attrs: { "data-price-vendor": _vm.plan.price_vendor }
        },
        [
          _vm.useMobileStyling && _vm.useExperimentStyling
            ? _c("div", { staticClass: "mobile-plan" }, [
                _c("span", [
                  _vm._v("\n      " + _vm._s(_vm.plan.display_name) + "\n    ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm.plan.strikethrough_price
                    ? _c("s", { staticClass: "original" }, [
                        _vm._v(_vm._s(_vm.plan.strikethrough_price))
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n      " + _vm._s(_vm.plan.display_price) + "\n      "
                  ),
                  _c("small", [_vm._v("/month*")])
                ])
              ])
            : _c("div", { class: { "plan-card": _vm.useExperimentStyling } }, [
                _c("h4", [
                  _vm._v("\n      " + _vm._s(_vm.plan.display_name) + "\n    ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  _c("h5", [
                    _c("s", { staticClass: "original" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.plan.strikethrough_price) +
                          "\n        "
                      )
                    ]),
                    _vm._v(
                      "\n\n        " +
                        _vm._s(_vm.plan.display_price) +
                        "\n\n        "
                    ),
                    _c("small", [_vm._v(" /month*")])
                  ]),
                  _vm._v(" "),
                  _vm.showSuscribebutton
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:click",
                              value: {
                                axId: _vm.trackUiEvent(_vm.plan.interval)
                              },
                              expression:
                                "{ axId: trackUiEvent(plan.interval) }",
                              arg: "click"
                            }
                          ],
                          staticClass: "btn btn-green",
                          on: {
                            click: function($event) {
                              return _vm.handleSubscribeNowClick(
                                _vm.plan.checkout_url
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.upgrade
                                  ? "Switch to " + _vm.plan.display_name
                                  : "Subscribe now"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
        ]
      )
    : _c(
        "PaywallPlanMini",
        {
          attrs: {
            axId: _vm.trackUiEvent(_vm.plan.interval),
            "data-price-vendor": _vm.plan.price_vendor,
            subpack: _vm.shouldShowSubpack
          },
          on: {
            "plan-clicked": function($event) {
              return _vm.handleSubscribeNowClick(_vm.plan.checkout_url)
            }
          }
        },
        [
          _c(
            "h4",
            {
              class: {
                "plan-name": true,
                "grid-plan-name": _vm.shouldShowSubpack
              },
              attrs: { slot: "plan-name" },
              slot: "plan-name"
            },
            [_vm._v("\n    " + _vm._s(_vm.plan.display_name) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "h5",
            {
              class: {
                "plan-price": true,
                "grid-plan-price": _vm.shouldShowSubpack
              },
              attrs: { slot: "plan-price" },
              slot: "plan-price"
            },
            [
              _vm.plan.strikethrough_price
                ? _c("s", { staticClass: "original" }, [
                    _vm._v(_vm._s(_vm.plan.strikethrough_price))
                  ])
                : _vm._e(),
              _vm._v("\n    " + _vm._s(_vm.plan.display_price) + "\n    "),
              _c("small", [_vm._v("/month*")])
            ]
          ),
          _vm._v(" "),
          _vm.subpack
            ? _c(
                "h5",
                {
                  staticClass: "plan-period",
                  attrs: { slot: "plan-period" },
                  slot: "plan-period"
                },
                [_c("small", [_vm._v("(Annual)")])]
              )
            : _vm._e()
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }